import { UPDATE_CONVERSE } from 'stores/types/chat'

const state = {
  converse: null
}

// getters
const getters = {
  converse: state => state.converse
}

const actions = {
  updateConverseInstance(ctx, _converse) {
    ctx.commit(UPDATE_CONVERSE, _converse)
  }
}

const mutations = {
  UPDATE_CONVERSE(state, _converse) {
    state.converse = _converse
  }
}

export default {
  getters,
  state,
  mutations,
  actions
}
